import { render, staticRenderFns } from "./MenuBot.vue?vue&type=template&id=58dc5cdf"
import script from "./MenuBot.vue?vue&type=script&lang=js"
export * from "./MenuBot.vue?vue&type=script&lang=js"
import style0 from "./MenuBot.vue?vue&type=style&index=0&id=58dc5cdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports